import React from 'react';
import { AlertCircle, CheckCircle, Info, AlertTriangle, X } from 'lucide-react';

const styles = {
  error: { bg: 'bg-red-50 border-red-200', text: 'text-red-800', Icon: AlertCircle },
  success: { bg: 'bg-green-50 border-green-200', text: 'text-green-800', Icon: CheckCircle },
  warning: { bg: 'bg-yellow-50 border-yellow-200', text: 'text-yellow-800', Icon: AlertTriangle },
  info: { bg: 'bg-blue-50 border-blue-200', text: 'text-blue-800', Icon: Info },
};

export const Alert = ({ type = 'info', children, onClose, className = '' }) => {
  const style = styles[type];
  const AlertIcon = style.Icon;

  return (
    <div className={`flex items-start gap-3 p-3 rounded-lg border ${style.bg} ${className}`}>
      <AlertIcon className={`h-4 w-4 mt-0.5 flex-shrink-0 ${style.text}`} />
      <div className={`flex-1 text-sm ${style.text}`}>{children}</div>
      {onClose && (
        <button onClick={onClose} className={`${style.text} hover:opacity-70`}>
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
